import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./UseCasesPage.css";

const useCases = [
  {
    title: "Game servers & dedicated workloads",
    icon: "fa-server",
    summary: "Run game servers, bots, or other demanding applications on dedicated hardware with full control.",
    products: "Baremetal Servers",
    link: "/#hn-plans",
  },
  {
    title: "Development & staging",
    icon: "fa-code",
    summary: "Spin up consistent dev and staging environments. Get a DevOps professional to deploy and maintain your stack.",
    products: "DevOps Services, Virtual Servers",
    link: "/#hn-plans-devop",
  },
  {
    title: "Remote work & access",
    icon: "fa-desktop",
    summary: "Access a remote desktop from anywhere with fast servers, free P2P, and unlimited connection time.",
    products: "Noodle Remote Desktop",
    link: "/#hn-plans-remote",
  },
  {
    title: "Small teams & scalable compute",
    icon: "fa-cloud",
    summary: "Add cloud capacity without managing infrastructure. Pay per seat and scale as your team grows.",
    products: "Virtual Servers, Noodle Cloud Processing",
    link: "/#hn-plans-cloud",
  },
  {
    title: "Email & multi-environment hosting",
    icon: "fa-envelope",
    summary: "Full email server setup, multi-environment deployment, and priority support for combined compute and email needs.",
    products: "Noodle DevOp – Pro",
    link: "/#hn-plans-devop",
  },
];

const UseCasesPage = () => (
  <>
    <Navbar />
    <main className="hn-usecases-main">
      <Container className="py-4 py-md-5">
        <div className="hn-usecases-header text-center mb-5">
          <h1 className="hn-usecases-title">Use cases</h1>
          <p className="hn-usecases-intro">
            See how Hosting Noodle fits your needs. From dedicated game servers to remote desktops and managed DevOps, we have a plan for you.
          </p>
        </div>
        <Row className="g-4">
          {useCases.map((uc, idx) => (
            <Col key={idx} md="6" lg="4">
              <Card className="hn-usecases-card h-100">
                <CardBody>
                  <div className="hn-usecases-icon-wrap">
                    <i className={`fas ${uc.icon} hn-usecases-icon`} aria-hidden="true" />
                  </div>
                  <h2 className="hn-usecases-card-title">{uc.title}</h2>
                  <p className="hn-usecases-card-summary">{uc.summary}</p>
                  <p className="hn-usecases-card-products small text-muted mb-3">
                    <strong>Products:</strong> {uc.products}
                  </p>
                  <Link to={uc.link} className="hn-usecases-link">
                    View plans <i className="fas fa-arrow-right ms-1" aria-hidden="true" />
                  </Link>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </main>
    <Footer />
  </>
);

export default UseCasesPage;
